module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/desktop-banner-beb02021bcfd7ad6dc23d91f944a108d.png";